<template>
  <div class="shipping_bar" :id="id" v-if="ready && this.tiers && this.tiers.length">
    <!--Hey!<button @click="log">How am I?</button>-->
    <shipping_progress_bar :id="id" :cart-total="cartTotal" :current-tier="currentTier" :prev-tier="highestAchievedTier" :shown="shown" :delay="delay">
    </shipping_progress_bar>
  </div>
</template>

<script>
  export default {
    name: 'shipping_bar',
    props: ['id', 'tiers', 'cartTotal', 'shown', 'delay', 'ready'],
    computed: {
      currentTier: function() {
        // const { centsInCurrency } = this.$options.filters;

        // because .sort mutates in place, we sort a shallow copy created with [...]
        const tiersAscending = [ ...this.tiers ].sort((a, b) => { return a.min_spend - b.min_spend });
        // Return the current tier. This will be the tier with the lowest total that we do not qualify for, or if there are no tiers we do not qualify for, the tier with the highest total.
        return tiersAscending.find(tier => (tier.min_spend * 100) > this.cartTotal) || tiersAscending[tiersAscending.length - 1];
      },
      highestAchievedTier: function() {
        // const { centsInCurrency } = this.$options.filters;

        const tiersAscending = [ ...this.tiers ].sort((a, b) => { return a.min_spend - b.min_spend });
        const achievedTiers = tiersAscending.filter(tier => (tier.min_spend * 100) <= this.cartTotal);
        return achievedTiers[achievedTiers.length - 1];
      }
    },
    methods: {  
      log: function(e) {
        console.log(this);
        console.log(this.tiers);
        console.log(this.cartTotal);
        console.log(this.currentTier);
      },
    },
  }
</script>